// extracted by mini-css-extract-plugin
export default {"content":"VaccinesPage_content__LusUB"};